import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import "./Login.css";
import Swal from 'sweetalert2';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const { authFetch, refreshCsrfToken, csrfToken } = useContext(AuthContext);

  useEffect(() => {
    if (!csrfToken) {
      refreshCsrfToken();
    }
  }, [csrfToken, refreshCsrfToken]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setIsError(false);

    try {
      const response = await authFetch(`${API_BASE_URL}/Users/password/forgot`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setEmail("");
        
        Swal.fire({
          title: 'Email Sent',
          text: 'If your email is registered, you will receive a password reset link shortly.',
          icon: 'success',
          confirmButtonColor: '#2486d2',
        });
      } else {
        if (response.status === 429) {
          setIsError(true);
          setMessage("Too many password reset attempts. Please try again later.");
        } else {
          setIsError(true);
          setMessage(data.message || "An error occurred. Please try again later.");
        }
      }
    } catch (error) {
      setIsError(true);
      setMessage("Connection error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="user-login-container">
        <div className="user-login-loading">
          <div className="user-login-spinner"></div>
          <p>Processing your request...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="user-login-container">
      <div className="user-login-wrapper">
        <div className="user-login-mobile-form-container">
          <div className="user-login-form-box">
            <form onSubmit={handleSubmit} className="user-login-form">
              <h1>Reset Password</h1>
              <span>Enter your email to receive a password reset link</span>

              {message && (
                <div className={isError ? "user-login-error" : "user-login-success"}>
                  {message}
                </div>
              )}

              <div className="user-login-input-group">
                <input
                  type="email"
                  className="user-login-input"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>

              <button type="submit" className="user-login-button">
                Send Reset Link
              </button>

              <div className="user-login-mobile-switch">
                <p>Remember your password?</p>
                <Link to="/login" className="user-login-text-button">
                  Back to Login
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;